module.exports = __webpack_public_path__ + "img/spiderman.603763bb.jpg";